import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/PaymentSuccess.css'; // Optional: for styling

const PaymentSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="success-container">
      <div className="success-card">
        <div className="success-checkmark">✓</div>
        <h1>Payment Successful!</h1>
        <p>Thank you for subscribing. Your account has been upgraded and is now active.</p>
        <div className="success-buttons">
          <button 
            className="button-secondary" 
            onClick={() => navigate('/')}
          >
            Go to Homepage
          </button>
          <button 
            className="button-primary" 
            onClick={() => navigate('/interview-config')}
          >
            Start an Interview
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;